/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TemplatesIndexRouteImport } from './routes/templates/index'
import { Route as TeamPresetsIndexRouteImport } from './routes/team-presets/index'
import { Route as SessionsIndexRouteImport } from './routes/sessions/index'
import { Route as PlayersIndexRouteImport } from './routes/players/index'
import { Route as PlayerGroupsIndexRouteImport } from './routes/player-groups/index'
import { Route as ImagesIndexRouteImport } from './routes/images/index'
import { Route as GamesIndexRouteImport } from './routes/games/index'
import { Route as AnalyticsIndexRouteImport } from './routes/analytics/index'
import { Route as TemplatesNewRouteImport } from './routes/templates/new'
import { Route as TeamPresetsNewRouteImport } from './routes/team-presets/new'
import { Route as TeamPresetsPresetIdRouteImport } from './routes/team-presets/$presetId'
import { Route as SessionsNewRouteImport } from './routes/sessions/new'
import { Route as SessionsSessionIdRouteImport } from './routes/sessions/$sessionId'
import { Route as PlayersPlayerIdRouteImport } from './routes/players/$playerId'
import { Route as PlayerGroupsGroupIdRouteImport } from './routes/player-groups/$groupId'
import { Route as GamesNewRouteImport } from './routes/games/new'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as TemplatesTemplateIdEditRouteImport } from './routes/templates/$templateId/edit'
import { Route as TeamPresetsPresetIdEditRouteImport } from './routes/team-presets/$presetId/edit'
import { Route as GamesGameIdEditRouteImport } from './routes/games/$gameId/edit'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamPresetsIndexRoute = TeamPresetsIndexRouteImport.update({
  id: '/team-presets/',
  path: '/team-presets/',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsIndexRoute = SessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayersIndexRoute = PlayersIndexRouteImport.update({
  id: '/players/',
  path: '/players/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayerGroupsIndexRoute = PlayerGroupsIndexRouteImport.update({
  id: '/player-groups/',
  path: '/player-groups/',
  getParentRoute: () => rootRouteImport,
} as any)
const ImagesIndexRoute = ImagesIndexRouteImport.update({
  id: '/images/',
  path: '/images/',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIndexRoute = GamesIndexRouteImport.update({
  id: '/games/',
  path: '/games/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesNewRoute = TemplatesNewRouteImport.update({
  id: '/templates/new',
  path: '/templates/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamPresetsNewRoute = TeamPresetsNewRouteImport.update({
  id: '/team-presets/new',
  path: '/team-presets/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamPresetsPresetIdRoute = TeamPresetsPresetIdRouteImport.update({
  id: '/team-presets/$presetId',
  path: '/team-presets/$presetId',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsNewRoute = SessionsNewRouteImport.update({
  id: '/sessions/new',
  path: '/sessions/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsSessionIdRoute = SessionsSessionIdRouteImport.update({
  id: '/sessions/$sessionId',
  path: '/sessions/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayersPlayerIdRoute = PlayersPlayerIdRouteImport.update({
  id: '/players/$playerId',
  path: '/players/$playerId',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayerGroupsGroupIdRoute = PlayerGroupsGroupIdRouteImport.update({
  id: '/player-groups/$groupId',
  path: '/player-groups/$groupId',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesNewRoute = GamesNewRouteImport.update({
  id: '/games/new',
  path: '/games/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesTemplateIdEditRoute = TemplatesTemplateIdEditRouteImport.update({
  id: '/templates/$templateId/edit',
  path: '/templates/$templateId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamPresetsPresetIdEditRoute = TeamPresetsPresetIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => TeamPresetsPresetIdRoute,
} as any)
const GamesGameIdEditRoute = GamesGameIdEditRouteImport.update({
  id: '/games/$gameId/edit',
  path: '/games/$gameId/edit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/settings': typeof SettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/games/new': typeof GamesNewRoute
  '/player-groups/$groupId': typeof PlayerGroupsGroupIdRoute
  '/players/$playerId': typeof PlayersPlayerIdRoute
  '/sessions/$sessionId': typeof SessionsSessionIdRoute
  '/sessions/new': typeof SessionsNewRoute
  '/team-presets/$presetId': typeof TeamPresetsPresetIdRouteWithChildren
  '/team-presets/new': typeof TeamPresetsNewRoute
  '/templates/new': typeof TemplatesNewRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/games': typeof GamesIndexRoute
  '/images': typeof ImagesIndexRoute
  '/player-groups': typeof PlayerGroupsIndexRoute
  '/players': typeof PlayersIndexRoute
  '/sessions': typeof SessionsIndexRoute
  '/team-presets': typeof TeamPresetsIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/games/$gameId/edit': typeof GamesGameIdEditRoute
  '/team-presets/$presetId/edit': typeof TeamPresetsPresetIdEditRoute
  '/templates/$templateId/edit': typeof TemplatesTemplateIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/settings': typeof SettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/games/new': typeof GamesNewRoute
  '/player-groups/$groupId': typeof PlayerGroupsGroupIdRoute
  '/players/$playerId': typeof PlayersPlayerIdRoute
  '/sessions/$sessionId': typeof SessionsSessionIdRoute
  '/sessions/new': typeof SessionsNewRoute
  '/team-presets/$presetId': typeof TeamPresetsPresetIdRouteWithChildren
  '/team-presets/new': typeof TeamPresetsNewRoute
  '/templates/new': typeof TemplatesNewRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/games': typeof GamesIndexRoute
  '/images': typeof ImagesIndexRoute
  '/player-groups': typeof PlayerGroupsIndexRoute
  '/players': typeof PlayersIndexRoute
  '/sessions': typeof SessionsIndexRoute
  '/team-presets': typeof TeamPresetsIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/games/$gameId/edit': typeof GamesGameIdEditRoute
  '/team-presets/$presetId/edit': typeof TeamPresetsPresetIdEditRoute
  '/templates/$templateId/edit': typeof TemplatesTemplateIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/settings': typeof SettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/games/new': typeof GamesNewRoute
  '/player-groups/$groupId': typeof PlayerGroupsGroupIdRoute
  '/players/$playerId': typeof PlayersPlayerIdRoute
  '/sessions/$sessionId': typeof SessionsSessionIdRoute
  '/sessions/new': typeof SessionsNewRoute
  '/team-presets/$presetId': typeof TeamPresetsPresetIdRouteWithChildren
  '/team-presets/new': typeof TeamPresetsNewRoute
  '/templates/new': typeof TemplatesNewRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/games/': typeof GamesIndexRoute
  '/images/': typeof ImagesIndexRoute
  '/player-groups/': typeof PlayerGroupsIndexRoute
  '/players/': typeof PlayersIndexRoute
  '/sessions/': typeof SessionsIndexRoute
  '/team-presets/': typeof TeamPresetsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/games/$gameId/edit': typeof GamesGameIdEditRoute
  '/team-presets/$presetId/edit': typeof TeamPresetsPresetIdEditRoute
  '/templates/$templateId/edit': typeof TemplatesTemplateIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/settings'
    | '/auth/callback'
    | '/games/new'
    | '/player-groups/$groupId'
    | '/players/$playerId'
    | '/sessions/$sessionId'
    | '/sessions/new'
    | '/team-presets/$presetId'
    | '/team-presets/new'
    | '/templates/new'
    | '/analytics'
    | '/games'
    | '/images'
    | '/player-groups'
    | '/players'
    | '/sessions'
    | '/team-presets'
    | '/templates'
    | '/games/$gameId/edit'
    | '/team-presets/$presetId/edit'
    | '/templates/$templateId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/settings'
    | '/auth/callback'
    | '/games/new'
    | '/player-groups/$groupId'
    | '/players/$playerId'
    | '/sessions/$sessionId'
    | '/sessions/new'
    | '/team-presets/$presetId'
    | '/team-presets/new'
    | '/templates/new'
    | '/analytics'
    | '/games'
    | '/images'
    | '/player-groups'
    | '/players'
    | '/sessions'
    | '/team-presets'
    | '/templates'
    | '/games/$gameId/edit'
    | '/team-presets/$presetId/edit'
    | '/templates/$templateId/edit'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/settings'
    | '/auth/callback'
    | '/games/new'
    | '/player-groups/$groupId'
    | '/players/$playerId'
    | '/sessions/$sessionId'
    | '/sessions/new'
    | '/team-presets/$presetId'
    | '/team-presets/new'
    | '/templates/new'
    | '/analytics/'
    | '/games/'
    | '/images/'
    | '/player-groups/'
    | '/players/'
    | '/sessions/'
    | '/team-presets/'
    | '/templates/'
    | '/games/$gameId/edit'
    | '/team-presets/$presetId/edit'
    | '/templates/$templateId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  SettingsRoute: typeof SettingsRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  GamesNewRoute: typeof GamesNewRoute
  PlayerGroupsGroupIdRoute: typeof PlayerGroupsGroupIdRoute
  PlayersPlayerIdRoute: typeof PlayersPlayerIdRoute
  SessionsSessionIdRoute: typeof SessionsSessionIdRoute
  SessionsNewRoute: typeof SessionsNewRoute
  TeamPresetsPresetIdRoute: typeof TeamPresetsPresetIdRouteWithChildren
  TeamPresetsNewRoute: typeof TeamPresetsNewRoute
  TemplatesNewRoute: typeof TemplatesNewRoute
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
  GamesIndexRoute: typeof GamesIndexRoute
  ImagesIndexRoute: typeof ImagesIndexRoute
  PlayerGroupsIndexRoute: typeof PlayerGroupsIndexRoute
  PlayersIndexRoute: typeof PlayersIndexRoute
  SessionsIndexRoute: typeof SessionsIndexRoute
  TeamPresetsIndexRoute: typeof TeamPresetsIndexRoute
  TemplatesIndexRoute: typeof TemplatesIndexRoute
  GamesGameIdEditRoute: typeof GamesGameIdEditRoute
  TemplatesTemplateIdEditRoute: typeof TemplatesTemplateIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/': {
      id: '/templates/'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team-presets/': {
      id: '/team-presets/'
      path: '/team-presets'
      fullPath: '/team-presets'
      preLoaderRoute: typeof TeamPresetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/': {
      id: '/sessions/'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof SessionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/players/': {
      id: '/players/'
      path: '/players'
      fullPath: '/players'
      preLoaderRoute: typeof PlayersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/player-groups/': {
      id: '/player-groups/'
      path: '/player-groups'
      fullPath: '/player-groups'
      preLoaderRoute: typeof PlayerGroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/images/': {
      id: '/images/'
      path: '/images'
      fullPath: '/images'
      preLoaderRoute: typeof ImagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/': {
      id: '/games/'
      path: '/games'
      fullPath: '/games'
      preLoaderRoute: typeof GamesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/new': {
      id: '/templates/new'
      path: '/templates/new'
      fullPath: '/templates/new'
      preLoaderRoute: typeof TemplatesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team-presets/new': {
      id: '/team-presets/new'
      path: '/team-presets/new'
      fullPath: '/team-presets/new'
      preLoaderRoute: typeof TeamPresetsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team-presets/$presetId': {
      id: '/team-presets/$presetId'
      path: '/team-presets/$presetId'
      fullPath: '/team-presets/$presetId'
      preLoaderRoute: typeof TeamPresetsPresetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/new': {
      id: '/sessions/new'
      path: '/sessions/new'
      fullPath: '/sessions/new'
      preLoaderRoute: typeof SessionsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/$sessionId': {
      id: '/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/sessions/$sessionId'
      preLoaderRoute: typeof SessionsSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/players/$playerId': {
      id: '/players/$playerId'
      path: '/players/$playerId'
      fullPath: '/players/$playerId'
      preLoaderRoute: typeof PlayersPlayerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/player-groups/$groupId': {
      id: '/player-groups/$groupId'
      path: '/player-groups/$groupId'
      fullPath: '/player-groups/$groupId'
      preLoaderRoute: typeof PlayerGroupsGroupIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/new': {
      id: '/games/new'
      path: '/games/new'
      fullPath: '/games/new'
      preLoaderRoute: typeof GamesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/$templateId/edit': {
      id: '/templates/$templateId/edit'
      path: '/templates/$templateId/edit'
      fullPath: '/templates/$templateId/edit'
      preLoaderRoute: typeof TemplatesTemplateIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team-presets/$presetId/edit': {
      id: '/team-presets/$presetId/edit'
      path: '/edit'
      fullPath: '/team-presets/$presetId/edit'
      preLoaderRoute: typeof TeamPresetsPresetIdEditRouteImport
      parentRoute: typeof TeamPresetsPresetIdRoute
    }
    '/games/$gameId/edit': {
      id: '/games/$gameId/edit'
      path: '/games/$gameId/edit'
      fullPath: '/games/$gameId/edit'
      preLoaderRoute: typeof GamesGameIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface TeamPresetsPresetIdRouteChildren {
  TeamPresetsPresetIdEditRoute: typeof TeamPresetsPresetIdEditRoute
}

const TeamPresetsPresetIdRouteChildren: TeamPresetsPresetIdRouteChildren = {
  TeamPresetsPresetIdEditRoute: TeamPresetsPresetIdEditRoute,
}

const TeamPresetsPresetIdRouteWithChildren =
  TeamPresetsPresetIdRoute._addFileChildren(TeamPresetsPresetIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  SettingsRoute: SettingsRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  GamesNewRoute: GamesNewRoute,
  PlayerGroupsGroupIdRoute: PlayerGroupsGroupIdRoute,
  PlayersPlayerIdRoute: PlayersPlayerIdRoute,
  SessionsSessionIdRoute: SessionsSessionIdRoute,
  SessionsNewRoute: SessionsNewRoute,
  TeamPresetsPresetIdRoute: TeamPresetsPresetIdRouteWithChildren,
  TeamPresetsNewRoute: TeamPresetsNewRoute,
  TemplatesNewRoute: TemplatesNewRoute,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
  GamesIndexRoute: GamesIndexRoute,
  ImagesIndexRoute: ImagesIndexRoute,
  PlayerGroupsIndexRoute: PlayerGroupsIndexRoute,
  PlayersIndexRoute: PlayersIndexRoute,
  SessionsIndexRoute: SessionsIndexRoute,
  TeamPresetsIndexRoute: TeamPresetsIndexRoute,
  TemplatesIndexRoute: TemplatesIndexRoute,
  GamesGameIdEditRoute: GamesGameIdEditRoute,
  TemplatesTemplateIdEditRoute: TemplatesTemplateIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
